export default "__VITE_ASSET__BB5mW7u2__"